import { fetchAPI } from '../helpers';
import AppContext from '../AppContext';

class TagService {
    static getTags = (tagPrefix) => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token: token,
            url: `${config.TagService}${platformId}/${encodeURIComponent(tagPrefix)}`,
            method: 'GET',
            body: undefined
        });
    }
}

export default TagService;